var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * InterfaceFileFolder component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconInterfaceFileFolder extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.32133 2.64038C7.31336 2.64038 7.30571 2.64355 7.30007 2.64919C7.29443 2.65483 7.29126 2.66248 7.29126 2.67045V5.79074C7.29126 6.20495 6.95547 6.54074 6.54126 6.54074C6.12705 6.54074 5.79126 6.20495 5.79126 5.79074V2.67045C5.79126 2.26465 5.95246 1.87547 6.23941 1.58853C6.52635 1.30158 6.91553 1.14038 7.32133 1.14038H20.5825C20.9883 1.14038 21.3775 1.30158 21.6645 1.58853C21.9514 1.87547 22.1126 2.26465 22.1126 2.67045V8.91102C22.1126 9.32524 21.7768 9.66102 21.3626 9.66102C20.9484 9.66102 20.6126 9.32524 20.6126 8.91102V2.67045C20.6126 2.66248 20.6095 2.65483 20.6038 2.64919C20.5982 2.64355 20.5905 2.64038 20.5825 2.64038H7.32133ZM12.0317 5.79053C12.0317 5.37631 12.3675 5.04053 12.7817 5.04053H17.4622C17.8764 5.04053 18.2122 5.37631 18.2122 5.79053C18.2122 6.20474 17.8764 6.54053 17.4622 6.54053H12.7817C12.3675 6.54053 12.0317 6.20474 12.0317 5.79053ZM3.03909 8.25C2.04621 8.25 1.25222 9.07511 1.29038 10.0673L1.71346 21.0673C1.7496 22.0069 2.52184 22.75 3.46217 22.75H20.5486C21.4812 22.75 22.2499 22.0188 22.2965 21.0874L22.6965 13.0874C22.7464 12.0878 21.9495 11.25 20.9486 11.25H11.7206C11.613 11.25 11.5175 11.1811 11.4835 11.0791L10.9393 9.4466C10.7011 8.732 10.0324 8.25 9.27913 8.25H3.03909ZM2.78927 10.0096C2.78382 9.86787 2.89725 9.75 3.03909 9.75H9.27913C9.38674 9.75 9.48227 9.81886 9.5163 9.92094L10.0605 11.5534C10.2987 12.268 10.9674 12.75 11.7206 12.75H20.9486C21.0916 12.75 21.2055 12.8697 21.1983 13.0125L20.7983 21.0125C20.7917 21.1455 20.6819 21.25 20.5486 21.25H3.46217C3.32783 21.25 3.21751 21.1438 3.21235 21.0096L2.78927 10.0096Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconInterfaceFileFolder.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconInterfaceFileFolder.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconInterfaceFileFolder.prototype, "size", void 0);
if (customElements.get('cat-icon-interface-file-folder') === undefined) {
    customElements.define('cat-icon-interface-file-folder', BlocksIconInterfaceFileFolder);
}
